// Alongside the longitudinal SUMMARY workbook (isXlsxGradData), TEA delivers a per-student
// STUDENT LISTING workbook for each cohort. The Listing aggregates to the same numbers as the
// Summary (verified field-for-field against three real district files), so we accept it too and
// route it to the same dynamic FYLI/F5YLI/SYLI type. Title block differs from the Summary:
// 'LONGITUDINAL STUDENT LISTING:' (not 'SUMMARY REPORT') and 'District number:' (not 'District No.:').

// cell.text throws on merged cells whose master value is null (TEA's title block has those),
// so derive text from cell.value instead.
const cellText = (cell) => {
  const value = cell ? cell.value : null;
  if (value == null) {
    return '';
  }
  if (typeof value === 'object') {
    if (Array.isArray(value.richText)) {
      return value.richText.map((part) => part.text).join('');
    }
    if (value.text != null) {
      return String(value.text);
    }
    return '';
  }
  return String(value);
};

const isXlsxGradListing = (file) =>
  new Promise((resolve) => {
    const isXlsxFile =
      file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
      (file.name || '').toLowerCase().endsWith('.xlsx');
    if (!isXlsxFile) {
      resolve({ isValid: false });
      return;
    }
    const reader = new FileReader();
    reader.onerror = () => resolve({ isValid: false });
    reader.onload = async () => {
      try {
        const exceljsModule = await import('exceljs/dist/exceljs.min.js');
        const ExcelJS = exceljsModule.default || exceljsModule;
        const workbook = new ExcelJS.Workbook();
        await workbook.xlsx.load(reader.result);
        const sheet = workbook.worksheets[0];
        const titleBlock = [];
        for (let rowNumber = 1; rowNumber <= 10; rowNumber += 1) {
          titleBlock.push(cellText(sheet.getCell(`A${rowNumber}`)).trim());
        }
        const isConfidential = titleBlock.some((line) => /^C O N F I D E N T I A L$/.test(line));
        const hasDistrictNumber = titleBlock.some((line) => /^District number: \d{6}$/.test(line));
        const titleMatch = titleBlock
          .map((line) =>
            /^CLASS OF (\d{4}) (FOUR|FIVE|SIX)-YEAR (?:EXTENDED )?LONGITUDINAL STUDENT LISTING:?$/.exec(line)
          )
          .find(Boolean);
        if (isConfidential && hasDistrictNumber && titleMatch) {
          resolve({ isValid: true, assessmentYear: titleMatch[1], reportLength: titleMatch[2] });
          return;
        }
        resolve({ isValid: false });
      } catch (error) {
        resolve({ isValid: false });
      }
    };
    reader.readAsArrayBuffer(file);
  });

export default isXlsxGradListing;
